import { route } from 'react-router-typesafe-routes/dom';

export const ROUTES = {
  LOGIN: route(''),
  MAP: route('map'),
  SETTINGS: route(
    'settings',
    {},
    {
      GENERAL: route('general'),
      MAP: route('map'),
      WEB_MAP_SERVICES: route('web-map-services'),
      VECTOR_TILES: route('vector-tiles'),
      BASE_MAP: route('base-map'),
      BOOKMARKS: route('bookmarks'),
      AUTHENTICATION: route('authentication'),
    }
  ),
  MULTIFACTOR: route(
    'multifactor',
    {},
    {
      BEFORE_LOGIN: route('before-login'),
      AUTHENTICATED: route('authenticated'),
    }
  ),
};
